import { Controller } from "@hotwired/stimulus"

// A custom card's video (custom_figures/_hero_video on shared/_custom_card):
// it sits still on its poster, loading nothing, until it's picked up -- the
// pointer over its card, or on a phone, the card scrolled into view -- and
// plays while it's held there.
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.card = this.element.closest(".fc") || this.element
    if (window.matchMedia("(hover: hover)").matches) {
      this.enter = () => this.play()
      this.leave = () => this.element.pause()
      this.card.addEventListener("mouseenter", this.enter)
      this.card.addEventListener("mouseleave", this.leave)
    } else {
      this.observer = new IntersectionObserver(([ entry ]) => {
        entry.isIntersecting ? this.play() : this.element.pause()
      }, { threshold: 0.75 })
      this.observer.observe(this.element)
    }
  }

  disconnect() {
    this.card?.removeEventListener("mouseenter", this.enter)
    this.card?.removeEventListener("mouseleave", this.leave)
    this.observer?.disconnect()
  }

  play() {
    this.element.play().catch(() => {}) // blocked (Low Power Mode): the poster stays
  }
}
